import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import { PaymentInterfaceNew } from '../../../../new-lib/types/entity';
import { useRouter } from 'next/router';

interface ChildProps {
  plan: PaymentInterfaceNew;
}

const InformativePlan = ({ plan }: ChildProps) => {
  const { t } = useTranslation(['entity', 'common']);
  const { locale } = useRouter();

  return (
    <Plan className="compound-plan" locale={locale}>
      <div className="plan-content">
        <div className="down-payment">
          <span>{`${plan?.downPaymentPercentage}% `}</span>
          <span>{t('downpayment')} </span>
        </div>
        <div className="installment-years">
          {plan.years} {t('years')}{' '}
        </div>
      </div>
      {plan.isBackLoaded && (
        <div className="escalating-section">
          <div className="separator" />
          <div className="plan-type">
            {t('escalating_payments', { ns: 'common' })}
          </div>
        </div>
      )}
    </Plan>
  );
};

const Plan = styled.h3<any>`
  width: 368px;
  max-width: 368px;
  min-width: 368px;
  height: 60px;
  padding: 12px;
  border-radius: 8px;
  background: #f7f9fd;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  .plan-content {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
  }

  .down-payment {
    display: flex;
    align-items: center;
    gap: 6px;

    span {
      &:first-child {
        font-family: materialBold;
        font-size: 24px;
        color: #3e4042;
      }

      &:last-child {
        width: 55px;
        font-family: materialRegular;
        font-size: 12px;
        color: #3e4042;
      }
    }
  }

  .installment-years {
    font-family: materialRegular;
    font-size: 12px;
    color: #3e4042;
    align-self: ${props => (props.locale === 'en' ? 'flex-end' : 'center')};
  }

  .plan-type {
    width: 30%;
    font-family: materialMedium;
    font-size: 11px;
    color: #3e4042;
    display: flex;
    align-items: center;
    gap: 8px;
    .escalating-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      background: #edf1f6;
      padding: 4px;
    }
  }

  .escalating-section {
    max-width: 35%;
    display: flex;
    gap: 12px;
  }

  .separator {
    width: 1px;
    height: 36px;
    background: #d3dbe6;
  }

  .escalating-icon {
    position: relative;
    img {
      width: 18px;
      height: 18px;
    }
  }
`;

export default InformativePlan;
